import { useContent } from '../../../../hooks/use-server-content';

export interface QuietCardContentProps {
    desktopImagePath: string;
    mobileImagePath: string;
    headline: string;
    subHeadline: string;
    description: string;
    ctaLabel: string;
    ctaAriaLabel: string;
    ctaHref: string;
}
export const useQuietCardContent = (): QuietCardContentProps => {
    const [content, getValueByName] = useContent(
        'vehicles/vehicle-health-reports',
        'service-maintenance'
    );
    const contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment as QuietCardContentProps;
};
export default useQuietCardContent;
